import React, {ReactNode, Component, ChangeEvent} from 'react';
import I18n from 'app/i18n';
import InputError, {fieldErrorClass} from '../InputError';
import {inject, observer} from 'mobx-react';
import {DepositsStoreProps} from 'app/store/DepositsStore';
import AmountInput from 'app/components/reusable/AmountInput';

@inject('depositsStore')
@observer
export default class DepositPromoCode extends Component<DepositsStoreProps> {
    depositUpdatePromoCode = (event: ChangeEvent<HTMLInputElement>): void => {
        this.props.depositsStore.updatePromoCode(event.target.value);
    };

    render(): ReactNode {
        const {errors} = this.props.depositsStore;
        const error = errors['deposit_promo_code.promo_code'] || errors.promo_code;
        const {promoCode} = this.props.depositsStore;
        return <div className="form__row">
            <div className="form__row-item">
                <label className="form__row-label">{I18n.t('user.promo_code_label')}</label>
                <div className={fieldErrorClass(error)}>
                    <AmountInput
                        containerClassName="field__wrap"
                        className="field__input"
                        value={promoCode}
                        onChange={this.depositUpdatePromoCode}
                        autoComplete="off"
                    >
                        {error && <InputError error={error}/>}
                    </AmountInput>
                </div>
            </div>
        </div>;
    }
}
